import React from 'react';
import styled from '@emotion/styled';

const StyledDevModeIndicator = styled.div(props => ({
  backgroundColor: `red`,
  position: `absolute`,
  padding: `3px 8px`,
  borderRadius: props.theme.radius,
  right: `5px`
}));

const DevModeIndicator = () => {
  return <StyledDevModeIndicator> Dev Mode </StyledDevModeIndicator>;
};

export default DevModeIndicator;
